import { getGlobalLogger } from '@zg-rentals/logger-base';
const logger = getGlobalLogger(__filename);

export function onQueryError(error) {
  if (error) {
    logger.warn(error);
  }
}
